
// Utility: parse origins da ENV (CSV) → array pulito
function getAllowedParentOrigins() {
  const raw = process.env.REACT_APP_PARENT_ORIGINS || "";
  const list = raw
    .split(",")
    .map(s => s.trim())
    .filter(Boolean);

  // Fallback (se ENV non è settata): metti qui i tuoi parent noti
  if (list.length === 0) {
    //console.log('no env found.')
  }
  return list;
}

// Utility: prova a ricavare l'origin del parent dal referrer
function getParentOriginFromReferrer(allowedOrigins) {
  try {
    const ref = document.referrer || "";
    if (!ref) return null;
    const origin = new URL(ref).origin; // es. "https://collwww.fibercop.it"
    // consenti solo origin presenti nell'allow-list
    //console.log('origin rilevata', origin);
    if (allowedOrigins.includes(origin)) {
      //console.log('entrato nell if del allowed origins, con origin', origin);
      return origin;
    }
    return null;
  } catch (err){
    console.error(err);
    return null;
  }
}

// Utility: fallback “ambientale” se il referrer non aiuta
//function getFallbackParentOrigin(allowedOrigins) {
//  const host = window.location.hostname || "";
//  // Se l'app gira su stag (iframe di collaudo), prova a preferire un parent “collaudo”
//  if (/stag/i.test(host) || /collaudo/i.test(host)) {
//    // cerca nell'allow-list un dominio che *sembri* di collaudo
//    const cand = allowedOrigins.find(o => /collwww|collaudo|stag/i.test(o));
//    if (cand) return cand;
//  }
//  // altrimenti prendi il 1° della lista come default sicuro
//  return allowedOrigins[0] || null;
//}

// Calcola il targetOrigin sicuro per il parent
function resolveParentTargetOrigin() {
  const allowed = getAllowedParentOrigins();

  // 1) referrer
  const fromReferrer = getParentOriginFromReferrer(allowed);
  if (fromReferrer) return fromReferrer;


  // 2) fallback in base all'ambiente/domino corrente
  //return getFallbackParentOrigin(allowed);
}



export const trackEvent = (eventName, eventData = {}) => {

  const isEmbedded = Boolean(window.parent && window.parent !== window);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    source: isEmbedded ? "iframe" : "spa",
    ...eventData
  });

  // inoltro al parent (WordPress)
  try {
    //if (window.parent && window.parent !== window) {
    if (isEmbedded) {
      
      const targetOrigin = resolveParentTargetOrigin();
      
      if (!targetOrigin) {
        // niente origin affidabile → non invio
        console.warn('[gtmTracker] Nessun parent origin risolto, salto postMessage e tracker');
        return;
      }

      //console.log('target Origin trovato', targetOrigin);
      window.parent.postMessage(
        {
          type: "fc_gtm_event",   // marker personalizzato
          event: eventName,       // es. "address_search"
          data: eventData         // es. { indirizzo, codiceTopCliente }
        },
        targetOrigin              // dominio ESATTO del parent
      );
    }
  } catch {
    // no-op per sicurezza
  }
};






